import { Accordion, Group, Radio, Select, Stack, Text } from '@mantine/core';
import { GROUP_TRAINING_TYPE } from 'constant/course';
import React from 'react';
import styles from './styles.module.css';
import { Controller } from 'react-hook-form';
import { courseService } from 'services/lcms/course.service';
import { useQuery } from '@tanstack/react-query';

const groupTrainingTypeOptions = GROUP_TRAINING_TYPE;

interface DelivertDetailFormProps {
  control: any;
  errors: any;
}

const params = {
  pageSize: 100,
  pageNumber: 1
};

const DeliveryDetailForm: React.FC<DelivertDetailFormProps> = ({ control, errors }) => {
  const { data: dataModeOfDelivery, isPending: loadingModeOfDelivery } = useQuery({
    queryKey: ['getModeOfDelivery'],
    queryFn: () => courseService.getModeOfDelivery(params),
    staleTime: Infinity
  });

  const { data: dataLearningFormat, isPending: loadingLearningFormat } = useQuery({
    queryKey: ['getLearningFormat'],
    queryFn: () => courseService.getLearningFormat(params),
    staleTime: Infinity
  });

  const { data: dataGroupTrainingCommandCenter, isPending: loadingGroupTrainingCommandCenter } =
    useQuery({
      queryKey: ['getGroupTrainingCommandCenter'],
      queryFn: () => courseService.getGroupTrainingCommandCenter(params),
      staleTime: Infinity
    });

  // const { data: dataLevelOfTraining, isPending: loadingLevelOfTraining } = useQuery({
  //   queryKey: ['getLevelOfTraining'],
  //   queryFn: () => courseService.getLevelOfTraining(params),
  //   staleTime: Infinity
  // });

  return (
    <Accordion.Item className={styles.accordionItem} value='deliveryDetails'>
      <Accordion.Control className={styles.accordionControl}>Delivery Details</Accordion.Control>
      <Accordion.Panel className={styles.accordionPanel}>
        <Stack gap='lg' py={16}>
          <Controller
            name='deliveryType'
            control={control}
            render={({ field }) => (
              <>
                <Radio.Group
                  label='Modular/Non Modular'
                  value={field.value}
                  withAsterisk
                  onChange={(value) => field.onChange(value || '')}
                >
                  <Group mt='xs'>
                    <Radio value='modular' label='Modular' />
                    <Radio value='program' label='Program' />
                  </Group>
                </Radio.Group>
                {errors.deliveryType?.message && (
                  <Text size='xs' c={'red'}>
                    {errors.deliveryType?.message}
                  </Text>
                )}
              </>
            )}
          />
          <Controller
            name='modeOfDelivery'
            control={control}
            render={({ field }) => (
              <Select
                label='Mode of Delivery'
                withAsterisk
                placeholder='Select mode of delivery'
                data={
                  dataModeOfDelivery?.data.map(
                    (item: { id: number; option: string }) => item.option
                  ) || []
                }
                searchable
                disabled={loadingModeOfDelivery}
                error={errors.modeOfDelivery?.message}
                value={field.value}
                onChange={(value) => field.onChange(value || '')}
              />
            )}
          />
          <Controller
            name='groupTrainingType'
            control={control}
            render={({ field }) => (
              <Select
                label='Group Mode'
                placeholder='Select group mode'
                withAsterisk
                data={groupTrainingTypeOptions.map(
                  (item: { value: string; label: string }) => item.label
                )}
                searchable
                error={errors.groupTrainingType?.message}
                value={field.value}
                onChange={(value) => field.onChange(value || '')}
              />
            )}
          />

          {/* <Controller
            name='learningFormat'
            control={control}
            render={({ field }) => (
              <Select
                label='Course Format (optional)'
                placeholder='Select course format'
                data={
                  dataLearningFormat?.data.map(
                    (item: { id: number; option: string }) => item.option
                  ) || []
                }
                searchable
                disabled={loadingLearningFormat}
                error={errors.learningFormat?.message}
                value={field.value}
                onChange={(value) => field.onChange(value || '')}
              />
            )}
          /> */}

          <Controller
            name='grpTraining'
            control={control}
            render={({ field }) => (
              <Select
                label='Group Training (optional)'
                placeholder='Select group training'
                data={
                  dataGroupTrainingCommandCenter?.data.map(
                    (item: { id: number; option: string }) => ({
                      value: item.id.toString(),
                      label: item.option
                    })
                  ) || []
                }
                searchable
                disabled={loadingGroupTrainingCommandCenter}
                error={errors.grpTraining?.message}
                value={field.value}
                onChange={(value) => field.onChange(value || '')}
              />
            )}
          />

          {/* <Controller
            name='bcldLevel'
            control={control}
            render={({ field }) => (
              <Select
                label='BCLD Level'
                placeholder={loadingLevelOfTraining ? 'Loading...' : 'Select BCLD level'}
                data={
                  dataLevelOfTraining?.data.map((item: { id: number; option: string }) => ({
                    value: item.id.toString(),
                    label: item.option
                  })) || []
                }
                searchable
                disabled={loadingLevelOfTraining}
                error={errors.bcldLevel?.message as string}
                value={field.value}
                onChange={(value) => field.onChange(value || '')}
                withAsterisk
              />
            )}
          /> */}

          <Controller
            name='bcldStreamOrFunda'
            control={control}
            render={({ field }) => (
              <Select
                label='Compulsory or Optional'
                placeholder={
                  loadingLearningFormat ? 'Loading...' : 'Select Compulsory or Optional'
                }
                data={
                  dataLearningFormat?.data.map((item: { id: number; option: string }) => ({
                    value: item.id.toString(),
                    label: item.option
                  })) || []
                }
                searchable
                disabled={loadingLearningFormat}
                error={errors.bcldStreamOrFunda?.message as string}
                value={field.value}
                onChange={(value) => field.onChange(value || '')}
                withAsterisk
              />
            )}
          />
        </Stack>
      </Accordion.Panel>
    </Accordion.Item>
  );
};

export default DeliveryDetailForm;
